import React, { useEffect, useRef } from "react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Input, InputGroup } from "../../Catalyst/input";

interface UserSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  className?: string;
}

const UserSearchField = ({ value, onChange, onClear, className }: UserSearchFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleShortcut = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handleShortcut);
    return () => window.removeEventListener("keydown", handleShortcut);
  }, []);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Escape" && value) {
      event.preventDefault();
      onClear();
    }
  };

  return (
    <div role="search" className={`${className ?? ""} [&_input]:pr-10 sm:[&_input]:pr-8`}>
      <InputGroup>
        <MagnifyingGlassIcon />
        <Input
          ref={inputRef}
          name="userSearch"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Search users by name, email, or ID ⌘K"
          aria-label="Search users by name, email, or user ID"
          autoComplete="off"
        />
        {value && (
          <button
            type="button"
            onClick={() => {
              onClear();
              inputRef.current?.focus();
            }}
            aria-label="Clear search"
            className="absolute inset-y-0 right-0 z-10 flex w-10 items-center justify-center text-zinc-500 hover:text-texthead sm:w-8"
          >
            <XMarkIcon className="size-5 sm:size-4" />
          </button>
        )}
      </InputGroup>
    </div>
  );
};

export default UserSearchField;
